/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { Button, Modal, Transition } from "semantic-ui-react";
import TermsAndConditions from "./LandingPage/TermsAndConditions";
import cStyles from "../Components.module.css";
import { useTranslation } from "react-i18next";

interface TermsPopupProps {
  setPopupStateClosed: (closed: boolean) => void;
}

const TermsPopup: React.FC<TermsPopupProps> = ({ setPopupStateClosed }) => {
  const { t } = useTranslation("common");

  return (
    <Transition transitionOnMount animation="fade" duration="333">
      <Modal open={true} size="large">
        <title>{t("terms_title")}</title>
        <Modal.Content image scrolling style={{ backgroundColor: "#f8f6fa" }}>
          <div style={{ maxWidth: "1000px" }}>
            <TermsAndConditions />
          </div>
        </Modal.Content>
        <Modal.Actions style={{ margin: 0 }}>
          <Button
            className={cStyles.lpButton}
            onClick={() => setPopupStateClosed(true)}
          >
            {t("ok")}
          </Button>
        </Modal.Actions>
      </Modal>
    </Transition>
  );
};

export default TermsPopup;
